import { useContext } from 'react';
import { APIContext } from '../providers/api-provider';
export const useAPIProvider = () => {
  return useContext(APIContext);
};
export const useAPIProviderGetSignedUrl = () => {
  return useContext(APIContext).getSignedUrl;
};
export const useAPIProviderRegisterHotKeys = () => {
  return useContext(APIContext).registerHotKeys;
};